import ReportsIndex from './Index'
import ReportsView from './View'
import ReportsConsumerTab from './tab/Consumer'
import ReportsPerformanceTab from './tab/Performance'
import ReportsIntervalTab from './tab/Interval'

export default [
  {
    path: '/reports',
    name: 'reports',
    component: ReportsIndex,
    meta: {
      auth: true,
      permission: 'view',
    },
    children: [
      {
        path: ':energetics_id',
        name: 'reportView',
        redirect: '/reports/:energetics_id/consumer-report',
        component: ReportsView,
        children: [
          {
            path: 'consumer-report',
            name: 'reportConsumer',
            component: ReportsConsumerTab,
          },
          {
            path: 'performance-report',
            name: 'reportPerformance',
            component: ReportsPerformanceTab,
          },
          {
            path: 'interval-data',
            name: 'intervalData',
            component: ReportsIntervalTab,
          },
        ],
      },
    ],
  },
]
